import {
  BaseDropdown,
  BaseInput,
  LargeButton,
  Ptag,
  OverlayLoader,
} from "components/core";
import { Form, Formik, FieldArray } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import http from "services/httpService";
import { Divider, IconButton } from "@mui/material";
import styled from "styled-components";
import { WidthLimiter } from "pages/PlanSetup/styles";
import { useNavigate, useParams } from "react-router";
import routes from "components/routes";
import useUser from "hooks/useUser";
import closeIcon from "assets/svgs/close.svg";
import add_circle from "assets/svgs/add_circle.svg";
import {
  generateInitialValues,
  postCompanyData,
  validationSchema,
} from "pages/CompanySetup/constant";
import { disableFormBtnHandler } from "utlis/utils";

const BaseDivider = () => {
  return (
    <Divider
      style={{ marginTop: "5rem", marginBottom: "5rem", borderColor: "black" }}
    />
  );
};

function CompanyProfile() {
  const { type } = useParams();
  const { getRole } = useUser();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [industries, setIndustries] = useState({});
  const [employeerange, setEmployeeRange] = useState({});
  const [industrySector, setIndustrySector] = useState({});
  const [relationshipManager, setRelationshipManager] = useState({});
  const [servicingManager, setServicingManager] = useState({});
  const [profileData, setProfileData] = useState();
  const role = getRole();
  console.log({ role });
  const getOptions = (details) => {
    if (!Object.keys(details).length) return [];
    return details.map(({ display_name, value }) => ({
      label: display_name,
      value,
    }));
  };
  const getManagerOptions = (details) => {
    if (!Object.keys(details).length) return [];
    return details.map(({ name, id }) => ({
      label: name,
      value: id,
    }));
  };
  const initialValues = useMemo(() => {
    const return_data = generateInitialValues(profileData, type);
    return return_data;
  }, [profileData]);
  useEffect(() => {
    const fetchData = async () => {
      setLoader(true);

      try {
        const { data } = await http.get("business/get_company_setup_details/");
        setIndustries(data?.industry_type);
        setEmployeeRange(data?.range_of_employees);
        setIndustrySector(data?.industry_sector);
        setRelationshipManager(data?.relationship_managers);
        setServicingManager(data?.servicing_managers);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoader(false);
      }
    };
    const companyProfile = async () => {
      try {
        const { data } = await http.get("/business/get_company_profile/");
        setProfileData(data);
      } catch (e) {
        console.log(e);
      }
    };

    fetchData();
    if (type == "edit") {
      companyProfile();
    }
  }, []);
  const handleSubmit = async (values) => {
    // setLoader(true);
    try {
      const result = await postCompanyData(values, type);
      if (result) {
        localStorage.setItem("company_setup_data", JSON.stringify(values));
        if (type == "edit") {
          navigate(`/${routes.CARE_DASHBOARD}`);
        } else {
          navigate(`/${routes.PLAN_SELECTION}`);
        }
      }
    } catch (e) {
      console.log(e);
      // setLoader(false);
    }
  };

  const isDisabled = useMemo(() => {
    return role === "admin" ? false : true;
  }, [role]);

  const handleRemoveSecondaryContact = async (contact, index, remove) => {
    const contactId = contact?.user_id || contact?.id;
    if (!contactId) {
      remove(index);
      return;
    }
    try {
      await http.post("/business/delete_hr_contact/", {
        user_id: [contactId],
      });
      remove(index);
    } catch (e) {
      console.log(e);
      alert("Failed to delete HR contact. Please try again.");
    }
  };

  if (loader) return <OverlayLoader />;
  return (
    <section>
      <WidthLimiter>
        <Formik
          enableReinitialize
          validationSchema={validationSchema}
          initialValues={initialValues}
          onSubmit={handleSubmit}
        >
          {(formikProps) => (
            <div style={{ marginBottom: "2.8rem" }}>
              <Form
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "2rem",
                  marginTop: "2rem",
                }}
              >
                <BaseInput
                  staticLabel="Company Name (Policy Holder)"
                  fontSize="16px !important"
                  disabled={isDisabled}
                  formikProps={{
                    ...formikProps,
                    name: "company_name",
                  }}
                />
                <BaseInput
                  staticLabel="Parent Company (Optional)"
                  fontSize="16px !important"
                  disabled={isDisabled}
                  formikProps={{
                    ...formikProps,
                    name: "parent_company_name",
                  }}
                />
                <BaseDropdown
                  fontSize="16"
                  staticLabel="Number of Employees"
                  type="text"
                  disabled={isDisabled}
                  options={getOptions(employeerange)}
                  formikProps={{
                    ...formikProps,
                    name: "range_of_employees",
                  }}
                />
                <BaseDropdown
                  fontSize="16"
                  staticLabel="Industry Type"
                  type="text"
                  disabled={isDisabled}
                  options={getOptions(industries)}
                  formikProps={{ ...formikProps, name: "industry" }}
                />
                <BaseDropdown
                  fontSize="16"
                  staticLabel="Industry Sector"
                  type="text"
                  disabled={isDisabled}
                  options={getOptions(industrySector)}
                  formikProps={{ ...formikProps, name: "industry_sector" }}
                />
                <BaseDivider />
                <Ptag
                  fontSize="24px"
                  letterSpacing="0.25px"
                  fontWeight="700"
                  marginBottom="16px"
                  fontFamily="Montserrat"
                >
                  Address
                </Ptag>
                <BaseInput
                  staticLabel="Area/ Street/ Sector"
                  fontSize="16px !important"
                  disabled={isDisabled}
                  formikProps={{
                    ...formikProps,
                    name: "street",
                  }}
                />
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "68% 30%",
                    gridGap: "2%",
                  }}
                >
                  <BaseInput
                    staticLabel="City/ Town"
                    fontSize="16px !important"
                    disabled={isDisabled}
                    formikProps={{
                      ...formikProps,
                      name: "city",
                    }}
                  />
                  <BaseInput
                    staticLabel="Pincode"
                    pincode
                    disabled={isDisabled}
                    fontSize="16px !important"
                    formikProps={{
                      ...formikProps,
                      name: "pincode",
                    }}
                  />
                </div>
                <BaseInput
                  staticLabel="State"
                  fontSize="16px !important"
                  disabled={isDisabled}
                  formikProps={{
                    ...formikProps,
                    name: "state",
                  }}
                />
                <BaseDivider />
                <Ptag
                  fontSize="24px"
                  fontWeight="700"
                  fontFamily="Montserrat"
                >
                  HR Contact Details
                </Ptag>
                <ContactCard>
                  <ContactHeader>
                    <ContactTitle>HR Admin</ContactTitle>
                  </ContactHeader>
                  <BaseInput
                    staticLabel="Name"
                    fontSize="18px !important"
                    disabled={true}
                    formikProps={{
                      ...formikProps,
                      name: "primary_contact_name",
                    }}
                  />
                  <GridTwoColumns>
                    <BaseInput
                      staticLabel="Email"
                      fontSize="18px !important"
                      disabled={true}
                      formikProps={{
                        ...formikProps,
                        name: "email",
                      }}
                    />
                    <BaseInput
                      staticLabel="Mobile"
                      disabled={true}
                      phone
                      fontSize="16px !important"
                      formikProps={{
                        ...formikProps,
                        name: "phone",
                      }}
                    />
                  </GridTwoColumns>
                </ContactCard>

                <FieldArray name="secondary_contacts">
                  {({ insert, remove, push }) => (
                    <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
                      {formikProps.values.secondary_contacts && formikProps.values.secondary_contacts.length > 0 && formikProps.values.secondary_contacts.map((contact, index) => (
                        <ContactCard key={index} style={{ marginBottom: 0 }}>
                        <ContactHeader>
                          <ContactTitle>HR User</ContactTitle>
                          {!isDisabled && (
                            <IconButton
                              onClick={() => handleRemoveSecondaryContact(contact, index, remove)}
                              size="small"
                              style={{ padding: 0 }}
                            >
                              <img src={closeIcon} alt="Close" style={{ width: 24, height: 24 }} />
                            </IconButton>
                            )}
                          </ContactHeader>
                          <BaseInput
                            staticLabel="Name"
                            fontSize="16px !important"
                            disabled={isDisabled}
                            trimOnBlur
                            formikProps={{
                              ...formikProps,
                              name: `secondary_contacts.${index}.name`,
                            }}
                          />
                          <GridTwoColumns>
                            <BaseInput
                              staticLabel="Email"
                              fontSize="16px !important"
                              disabled={isDisabled}
                              formikProps={{
                                ...formikProps,
                                name: `secondary_contacts.${index}.email`,
                              }}
                            />
                            <BaseInput
                              staticLabel="Mobile"
                              phone
                              disabled={isDisabled}
                              fontSize="16px !important"
                              formikProps={{
                                ...formikProps,
                                name: `secondary_contacts.${index}.phone_no`,
                              }}
                            />
                          </GridTwoColumns>
                        </ContactCard>
                      ))}
                      {!isDisabled && (
                        <AddButton
                          type="button"
                          onClick={() => push({ name: "", email: "", phone_no: "" })}
                        >
                          <img src={add_circle} alt="Add" style={{ marginLeft: "18px", height: 20, width: 20 }} />
                          <Ptag fontSize="14px" fontWeight="500" fontFamily="Montserrat" style={{ marginLeft: "-5px" }}>
                            Add HR User
                          </Ptag>
                        </AddButton>
                      )}
                    </div>
                  )}
                </FieldArray>
                <BaseDivider />
                <Ptag
                  fontSize="24px"
                  fontWeight="700"
                  marginBottom="16px"
                  fontFamily="Montserrat"
                >
                  Point of Contact
                </Ptag>
                <BaseDropdown
                  fontSize="16"
                  multiple
                  staticLabel="Servicing Manager"
                  disabled={isDisabled}
                  type="text"
                  options={getManagerOptions(servicingManager)}
                  formikProps={{
                    ...formikProps,
                    name: "servicing_managers",
                  }}
                />
                <BaseDropdown
                  fontSize="16"
                  staticLabel="Relationship Manager"
                  type="text"
                  disabled={isDisabled}
                  multiple
                  options={getManagerOptions(relationshipManager)}
                  formikProps={{
                    ...formikProps,
                    name: "relationship_managers",
                  }}
                />
                {!isDisabled && (
                  <ButtonWrapper
                    style={{
                      marginTop: "4rem",
                    }}
                  >
                    <LargeButton
                      id=""
                      label={`${type == "edit" ? "Update" : "Proceed"}`}
                      type="submit"
                      // disabled={!formikProps.dirty}
                      // disabled={disableFormBtnHandler(formikProps.errors, formikProps.values)}
                      style={{
                        padding: "2rem",
                        opacity: disableFormBtnHandler(formikProps.errors, formikProps.values) ? 0.6 : 1,
                        // cursor: disableFormBtnHandler(formikProps.errors, formikProps.values) ? "not-allowed" : "pointer",
                      }}
                    />
                  </ButtonWrapper>
                )}
              </Form>
            </div>
          )}
        </Formik>
      </WidthLimiter>
    </section>
  );
}

export default CompanyProfile;

const ButtonWrapper = styled.div`
  max-width: 800px;
`;

const ContactCard = styled.div`
  background-color: #F6F3FF;
  border-radius: 8px;
  padding: 24px;
`;

const ContactHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ContactTitle = styled.h4`
  font-family: Montserrat;
  font-size: 18px;
  font-weight: 600;
  color: #1A1A1A;
  margin: 0;
`;

const GridTwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 24px;
  margin-top: 24px;
`;

const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: #1a1a1a;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  margin-top: 8px;
  &:hover {
    color: #440e69;
  }
`;
